import { Component, effect, model, untracked } from '@angular/core';

@Component({
  selector: 'lgb-message',
  standalone: false,
  templateUrl: './message.html',
  styleUrl: './message.css',
})
export class Message {
  readonly msg=model<string>();
  readonly error=model<string>();

  constructor(){
    effect(() => {
      if(this.msg())
        untracked(() => this.error.set(null));
    });

    effect(() => {
      if(this.error())
        untracked(() => this.msg.set(null));
    });
  }
}
